document.addEventListener('DOMContentLoaded', () => {
    const faqBlocks = document.querySelectorAll('.wp-block-klx-faq');

    faqBlocks.forEach(block => {
        const heading = block.querySelector('h3');
        const content = block.querySelector('.faq-block');

        heading.addEventListener('click', () => {
            block.classList.toggle('active');
            
            if (block.classList.contains('active')) {
                content.style.display = 'block';
                window.animate(content, {
                    opacity: [0, 1]
                }, {
                    duration: 0.3
                });
            } else {
                content.style.display = 'none';
            }
        });
    });
});
